import Vue from 'vue'
import Router from 'vue-router'

//供货商
const logion = () => import('../newPage/login/index.vue');
const prompt = () => import('../newPage/login/prompt.vue');
const protocol = () => import('../newPage/protocol/index.vue');
const NewbieGuide = () => import('../newPage/NewbieGuide/index.vue');
const layout = () => import('../components/layout/index.vue');
//库存管理
const inventoryManagement = () => import('../newPage/inventoryManagement/index.vue');
//我的订单
const myOrder = () => import('../newPage/myOrder/index.vue');
//我的提现
const myWithdrawal = () => import('../newPage/myWithdrawal/index.vue');
//账号信息
const accountInfo = () => import('../newPage/accountInfo/index.vue');
//官方采购查询
const officialProcurementEnquiries = () => import('../newPage/officialProcurementEnquiries/index.vue');

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      redirect: 'login',
    },
    {
      path: '/login',
      name: 'login',
      component: logion
    },
    {
      path: '/prompt',
      name: 'prompt',
      component: prompt
    },
    {
      path: '/protocol',
      name: 'protocol',
      component: protocol
    },
    {
      path: '/NewbieGuide',
      name: 'NewbieGuide',
      component: NewbieGuide
    },
    {
      path: '/layout',
      component: layout,
      redirect: "/inventoryManagement",
      children: [
        {
          path: "/inventoryManagement",
          name: "inventoryManagement",
          component: inventoryManagement,
          meta: {
            title: "库存管理"
          }
        },
        {
          path: "/myOrder",
          name: "myOrder",
          component: myOrder,
          meta: {
            title: "我的订单"
          }
        },
        {
          path: "/myWithdrawal",
          name: "myWithdrawal",
          component: myWithdrawal,
          meta: {
            title: "我的提现"
          }
        },
        {
          path: "/accountInfo",
          name: "accountInfo",
          component: accountInfo,
          meta: {
            title: "账号信息"
          }
        },
        {
          path: "/officialProcurementEnquiries",
          name: "officialProcurementEnquiries",
          component: officialProcurementEnquiries,
          meta: {
            title: "官方采购查询"
          },
        },
      ]
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return {x: 0, y: 0}
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js